// Vendors
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
// Types
import { GetStateApiResponseType } from 'types/get-state-api-response.type';
// Utilities
import { getCurrentOnboardingStateService } from 'services/get-state.service';

const getCurrentOnboardingStateResolver = async (): Promise<
  [GetStateApiResponseType] | [null, boolean]
> => {
  const [response, { status }] = await getCurrentOnboardingStateService();

  return requestHasSuccessStatus(status) ? [response] : [null, true];
};

export { getCurrentOnboardingStateResolver };
